import { ConcreteEncodable } from "./ConcreteEncodable";

import { AllocationRequestDataImplEncoder } from "../../encoder/AllocationRequestDataImplEncoder";

import * as CubiqTS from "../../index";
import { AllocationRequestData } from "../AllocationRequestData";

export class AllocationRequestDataImpl extends ConcreteEncodable implements AllocationRequestData {
  public static enType: string = "com.bcdfx.model.event.lifecycle.AllocationRequestDataImpl";

  /*FID=1*/
  public allocationReferenceId: string;
  /*FID=2*/
  public accountCode: string;
  /*FID=3*/
  public allocationQty: string;
  /*FID=4*/
  public allocationIntent: CubiqTS.OrderIntent;
  /*FID=5*/
  public markupQty: string;
  /*FID=6*/
  public markupType: CubiqTS.MarkUpType;
  /*FID=7*/
  public settleTenor: CubiqTS.Tenor;
  /*FID=8*/
  public settleDate: CubiqTS.StandardDate | null = null;
  /*FID=9*/
  public oboAccount: string;
  /*FID=10*/
  public fixedCcy: string;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = AllocationRequestDataImplEncoder.Instance;
    this.setEncodableType(AllocationRequestDataImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "AllocationRequestDataImpl[" +
      "allocationReferenceId=" +
      this.allocationReferenceId +
      "accountCode=" +
      this.accountCode +
      "allocationQty=" +
      this.allocationQty +
      "allocationIntent=" +
      this.allocationIntent +
      "markupQty=" +
      this.markupQty +
      "markupType=" +
      this.markupType +
      "settleTenor=" +
      this.settleTenor +
      "settleDate=" +
      this.settleDate +
      "oboAccount=" +
      this.oboAccount +
      "fixedCcy=" +
      this.fixedCcy +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
